// extracted by mini-css-extract-plugin
export default {"products":"Vv-z","card":"Wv-z","oosMessaging":"Xv-z"};